import userReducer from "store/slices/userSlice";
import authReducer from "store/slices/authSlice";
import analyticsReducer from "store/slices/analyticsSlice";
import rolesReducer from "store/slices/rolesSlice";
import pipelineReducer from "store/slices/pipelineSlice";
import candidateReducer from "store/slices/candidateSlice";
import searchReducer from "store/slices/searchSlice";
//import garmentColorReducer from "store/slices/garmentColorSlice";
export default {
  user: userReducer,
  auth: authReducer,
  analytics: analyticsReducer,
  roles: rolesReducer,
  pipeline: pipelineReducer,
  candidate: candidateReducer,
   search:searchReducer
  //agreement: agreementReducer,

  //garmentColor: garmentColorReducer,
};
